import React from "react";
import instagramIcon from 'assets/img/instagram.png';
import whatsappIcon from 'assets/img/whatsapp.png';


export default function ShareButton({social, shareMessage, insta_url}) {

    const clickShare = (social) => {
         window.gtag('event', 'social_share', {
        event_category: 'engagement',
        event_label: social,
        value: 1,
    });
    }

  const url = {
    whatsapp: `https://wa.me/?text=${shareMessage}`,
    instagram: insta_url ? insta_url : 'https://www.instagram.com/lekink_/' ,
  }

  return (
    <a
      href={url[social]}
      target="_blank"
      onClick={() => clickShare(social)}
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        color: "white",
        borderRadius: "0",
        textDecoration: "none",
        fontWeight: "bold",
        border: "0px",
        cursor: "pointer",
        marginRight: "8px",
      }}
    >

      {social === "whatsapp" &&
       <img src={whatsappIcon} className="w-7" />
}      {social === "instagram" && 
         <img src={instagramIcon} className="w-6" />
      }
    </a>
  );
}